import { render, staticRenderFns } from "./batchSet.vue?vue&type=template&id=0b974dac&scoped=true"
import script from "./batchSet.vue?vue&type=script&lang=js"
export * from "./batchSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b974dac",
  null
  
)

export default component.exports